import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/site/Logo";

const links = [
  { href: "#about", label: "About" },
  { href: "#products", label: "Products" },
  { href: "#reach", label: "Global Reach" },
  { href: "#process", label: "Process" },
  { href: "#insights", label: "Insights" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#1A3626]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-24">
        <Link to="/" data-testid="site-logo" className="flex items-center">
          <Logo size={44} variant={scrolled ? "dark" : "light"} />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`nav-link ${scrolled ? "text-[#1A3626]" : "text-white/90 hover:text-white"}`}
              style={scrolled ? {} : { color: "rgba(255,255,255,0.9)" }}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#rfq" data-testid="nav-rfq-button" className="hidden md:inline-flex btn-gold !py-3 !px-6 text-sm">
          Request a Quote
        </a>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className={`md:hidden ${scrolled ? "text-[#1A3626]" : "text-white"}`}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#1A3626]/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-[#1A3626] font-medium"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#rfq"
              className="btn-gold justify-center"
              onClick={() => setOpen(false)}
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
